import { Brand, createBranded } from '@deltasierra/type-utilities';

export type GoogleMyBusinessAccountResourceId = Brand<`${number}`, 'GoogleMyBusinessAccountResourceId'>;
export const GoogleMyBusinessAccountResourceId = createBranded<GoogleMyBusinessAccountResourceId>();
